import React, {useEffect, useState} from 'react';
import {ReactComponent as LogoAMB} from '../../assets/logos/logo-amb-full.svg';
import {ReactComponent as LogoSearch} from '../../assets/icons/buttons/system-search.svg';
import {ReactComponent as LogoLinks} from '../../assets/icons/buttons/social-network-original.svg';
import {HeaderDrawer} from '../header-drawer/header-drawer';
import {useTranslation} from 'react-i18next';

import './app-header.scss';

export const AppHeader = () => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [currentUrl, setCurrentUrl] = useState(window.location.href);
    const [selectedDrawer, setSelectedDrawer] = useState('');
    const [selectedLanguage, setSelectedLanguage] = useState('');
    const {i18n} = useTranslation();

    const handleOpenDrawer = (type:string) => {
        setDrawerOpen(!drawerOpen);
        setSelectedDrawer(type);
    };
    useEffect(() => {
        if (i18n.language === 'es') setSelectedLanguage('Castellano');
        if (i18n.language === 'en') setSelectedLanguage('English');
        if (i18n.language === 'ca') setSelectedLanguage('Català');
    }, [i18n.language, selectedLanguage]);
    useEffect(() => {
        const handleUrlChange = () => {
            if (window.location.href !== currentUrl) {
                setCurrentUrl(window.location.href);
                setDrawerOpen(false);
            }
        };
        const intervalId = setInterval(handleUrlChange, 1000);
        return () => clearInterval(intervalId);
    }, [currentUrl]);


    return (
        <div>
            <div className='header-wrapper'>
                <a href='/home'>
                    <LogoAMB style={{paddingTop: '5px'}}/>
                </a>
                <div className="header-icons-div">
                    <LogoSearch onClick={() => handleOpenDrawer('search')}/>
                    <LogoLinks onClick={() => handleOpenDrawer('media')}/>
                    <button onClick={() => handleOpenDrawer('lang')}>
                        <p>{selectedLanguage}
                            <span className="triangle"></span>
                        </p>
                    </button>
                </div>
            </div>
            <HeaderDrawer drawerType={selectedDrawer} drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen}/>
        </div>
    );
};
